export enum SubmissionGroupSortEnum {
  submissionGroupName_ASC = 'submissionGroup.name',
  submissionGroupName_DESC = '-submissionGroup.name',
  submissionGroupCreatedAt_ASC = 'submissionGroup.createdAt',
  submissionGroupCreatedAt_DESC = '-submissionGroup.createdAt',
}
